/**
 * @description Component-PortfolioTabs
 */
import './index.less';

import { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import SynTitleTabs from '@/components/Tabs/SynTitleTabs';
import { PORTFOLIO_TAB_ITEMS } from '@/constants/portfolio';
import { useWrappedVaults } from '@/features/vault/hook';
import usePortfolioParams from '@/hooks/portfolio/usePortfolioParams';
import { useChainId, useUserAddr } from '@/hooks/web3/useChain';
interface IPropTypes {
  className?: string;
}
const PortfolioTabs: FC<IPropTypes> = function () {
  const { t } = useTranslation();
  const tab = usePortfolioParams();
  const [value, setValue] = useState<PORTFOLIO_TAB_ITEMS>(PORTFOLIO_TAB_ITEMS.PORTFOLIO);
  const navigate = useNavigate();
  const chainId = useChainId();
  const userAddr = useUserAddr();
  const vaults = useWrappedVaults(chainId, userAddr);

  const hasDepositToVaults = vaults.some((vault) => vault.userDeposit.gt(0));

  const newTabList = useMemo(() => {
    const list: {
      key: PORTFOLIO_TAB_ITEMS;
      label: JSX.Element;
    }[] = [
      {
        key: PORTFOLIO_TAB_ITEMS.PORTFOLIO,
        label: <div className="syn-portfolio-tabs-label">{t('common.portfolioStr')}</div>,
      },
      {
        key: PORTFOLIO_TAB_ITEMS.HISTORY,
        label: t('common.history'),
      },
    ];
    // todo: if vault list has balance, add vault tab
    if (hasDepositToVaults) {
      list.push({
        key: PORTFOLIO_TAB_ITEMS.VAULT,
        label: t('launchpad.launchpadMenu'),
      });
    }

    return list;
  }, [t, hasDepositToVaults]);
  useEffect(() => {
    setValue(tab || PORTFOLIO_TAB_ITEMS.PORTFOLIO);
    // no deps
  }, [tab]);
  return (
    <SynTitleTabs
      wrapStyle={{ height: 24 }}
      tabsStyle={{ gap: 24 }}
      className="syn-portfolio-tabs"
      onClick={(key) => {
        setValue(key as PORTFOLIO_TAB_ITEMS);
        navigate(`/portfolio/${key}`);
      }}
      activeKey={value}
      items={newTabList}
    />
  );
};

export default PortfolioTabs;
